import React, { Suspense } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { ToastContainer } from "react-toastify";
import guestRoutes from "./routes/guestRoutes";
import authenticatedRoutes from "./routes/authenticatedRoutes";
import ReduxProvider from "./store/ReduxProvider";
import { selectIsAuthenticated } from "./store/slices/authSlice";

function AppContent() {
  const isAuthenticated = useSelector(selectIsAuthenticated);

  return (
    <BrowserRouter>
      <Suspense
        fallback={
          <div className="flex justify-center items-center min-h-screen">
            Loading...
          </div>
        }
      >
        <Routes>
          {/* Guest routes - accessible when not authenticated */}
          {guestRoutes.map((route, index) => (
            <Route key={`guest-${index}`} path={route.path} element={route.element} />
          ))}
          
          {authenticatedRoutes.map((route, index) => (
            <Route key={`auth-${index}`} path={route.path} element={route.element} />
          ))}
          
          <Route 
            path="*" 
            element={
              isAuthenticated ? (
                <Navigate to="/dashboard" replace />
              ) : (
                <Navigate to="/login" replace />
              )
            } 
          />
        </Routes>
      </Suspense>
      <ToastContainer />
    </BrowserRouter>
  );
}

function App() {
  return (
    <ReduxProvider>
      <AppContent />
    </ReduxProvider>
  );
}

export default App;
